export const URL_DYNAMIC_PAGE = '/custom-page';
export const DefaultIcon = 'menu_5';
